import React from 'react';

const FlowIcon = ({ className = "" }) => (
  <svg className={className} width="100" height="100" viewBox="0 0 100 100" fill="none">
    <circle cx="30" cy="30" r="12" stroke="currentColor" strokeWidth="3" fill="none"/>
    <circle cx="50" cy="70" r="12" stroke="currentColor" strokeWidth="3" fill="none"/>
    <circle cx="70" cy="30" r="12" stroke="currentColor" strokeWidth="3" fill="none"/>
    <path d="M36 38 L 44 62" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    <path d="M56 62 L 64 38" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    <path d="M42 30 L 58 30" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

export default FlowIcon;